import React, { createContext } from 'react';
import defaultConfiguration from '~/configuration';
import { Configuration } from '~/contracts';

type ContextType = {
  configuration: Configuration;
  dismissedNewPrice: number;
  referrer: string;
  verboseLoggingEnabled: boolean;
};

const defaultContext: ContextType = {
  configuration: defaultConfiguration,
  dismissedNewPrice: 0,
  referrer: '',
  verboseLoggingEnabled: false
};

const StaticContext = createContext<ContextType>(defaultContext);

export type OwnProps = React.PropsWithChildren<ContextType>;

export function StaticContextProvider({ children, ...value }: OwnProps) {
  return (
    <StaticContext.Provider value={value}>{children}</StaticContext.Provider>
  );
}

StaticContextProvider.displayName = 'StaticContextProvider';

export function useConfiguration() {
  return React.useContext(StaticContext).configuration;
}

export function useReferrer() {
  return React.useContext(StaticContext).referrer;
}

export function useVerboseLogging() {
  return React.useContext(StaticContext).verboseLoggingEnabled;
}

export default StaticContext;
